export const tabsData = [
  { label: 'Onboarded', key: 'onboarded' },
  { label: 'UpdateRequests', key: 'updateRequests' },
];

export const columnDefs = {
  onboarded: [
    { field: 'vendorName', headerName: 'Vendor' },
    { field: 'activeContractCount', headerName: 'Active contractors' },
    { field: 'address', headerName: 'Address' },
    { field: 'primaryContactName', headerName: 'POC' },
    { field: 'primaryContactEmail', headerName: 'Email' },
    { field: 'primaryContactPhone', headerName: 'Phone' },
  ],
  updateRequests: [
    { field: 'vendor', headerName: 'Vendor' },
    { field: 'changeType', headerName: 'Change Type' },
    { field: 'changeOldValue', headerName: 'Change old value' },
    { field: 'changeNewValue', headerName: 'Change new value' },
    { field: 'status', headerName: 'Status' },
    { field: 'action', headerName: 'Action', type: 'icon' },
  ],
};
